import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  const faqs = [{
    question: 'What is included in a full car detail?',
    answer: 'A full detail combines our complete interior and exterior services: deep vacuuming, shampooing, steam sanitizing, leather conditioning, a safe hand wash, clay bar decontamination, wheel and tire detailing, and premium paint protection.'
  }, {
    question: 'How long does a full detail take?',
    answer: 'A full detail typically takes 3\u20134 hours depending on the size and condition of your vehicle. We never rush \u2014 quality results take proper time and attention.'
  }, {
    question: 'How much does a full car detail cost?',
    answer: 'Our full detail starts at $300, with pricing adjusted for vehicle size and condition. SUVs and trucks are slightly higher. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'Is a full detail worth it before selling my car?',
    answer: 'Absolutely. A full detail is one of the most cost-effective ways to maximize resale value, presenting your vehicle in its best possible condition inside and out.'
  }, {
    question: 'Do you come to my home or office for a full detail?',
    answer: 'Yes. We are fully mobile and self-contained, bringing our own water and power to your home or office anywhere in Ventura County.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Full Car Detail',
    item: 'https://www.fulldetailpro.com/services/full-car-detail'
  }];
  return <ServicePageLayout title="Full Car Detail Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Complete full car detail in Ventura County \u2014 Camarillo, Oxnard & Thousand Oaks. Mobile interior deep clean + exterior wax & wax. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-641" data-mp="2ek28vy14spbi">
      <p data-id="element-642" data-mp="1vo2g4l0bxhqv">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-643" data-mp="1zo4dwj2y1r0v">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-644" data-mp="1s5mr5b624fpy">What's Included in a Full Detail?</h2>
      <p data-id="element-645" data-mp="1ndv77jhep88s">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-646" data-mp="1x3olwtcui3h9">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-647" data-mp="1x2d7lzlrxdbw">
        <li className="flex items-start" data-id="element-648" data-mp="1x5rcbehwtymi">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-649" data-mp="2b24qadn8jhw8" />
          <span data-id="element-650" data-mp="264cpeu4m4lfw">Wash method to safely remove surface dirt and grime.</span>
        </li>
        <li className="flex items-start" data-id="element-651" data-mp="gp6jw54np5e6">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-652" data-mp="gq7u67dulnuu" />
          <span data-id="element-653" data-mp="bqbtah0g6cji">
            <strong data-id="element-654" data-mp="bqv6jkf5kcr7">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-655" data-mp="i5spyswqnnuy">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-656" data-mp="i4r37r6d1cxe" />
          <span data-id="element-657" data-mp="n55cfcjp6sx0">
            <strong data-id="element-658" data-mp="n6q66zy6u7tt">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-659" data-mp="3qnggvs4pt91u">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-660" data-mp="3qkaskf3wub76" />
          <span data-id="element-661" data-mp="3vlrodw7jf7gw">
            <strong data-id="element-662" data-mp="3vj5mod7bvm6l">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-663" data-mp="97qhxtel7uy6">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-664" data-mp="37vxdhk6s3sza">
        <li className="flex items-start" data-id="element-665" data-mp="37vdwc5oyd8mb">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-666" data-mp="3cuh4hz08buyi" />
          <span className="font-[400]" data-id="element-667" data-mp="3csntk7il2okp">
            Deep Vacuuming: Thorough removal of dirt and pet hair, followed
            steam clean carpets and cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-668" data-mp="30a1z9z2rnsvp">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-669" data-mp="2vcijuvuc1a26" />
          <span data-id="element-670" data-mp="2vev27a405mfr">
            <strong data-id="element-671" data-mp="2qe79mk04kxjf">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-672" data-mp="2mege62znlt8k">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-673" data-mp="2hldh3kvo41nm" />
          <span data-id="element-674" data-mp="2cmk2tq8k46me">
            <strong data-id="element-675" data-mp="2cm0v12cmeym3">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-676" data-mp="22o4mmib2ihro">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-677" data-mp="22n2zvgkow6u4" />
          <span data-id="element-678" data-mp="1ym9cqpf2mw2a">
            <strong data-id="element-679" data-mp="1ynu7af1dyf05">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-680" data-mp="1t0ilxj67dekt">The Ultimate Value and Convenience</h2>
      <p data-id="element-681" data-mp="1t2bqmsx99oq6">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and power,
        allowing you to continue working or relaxing at home while we transform
        your car.
      </p>

      <h2 data-id="element-682" data-mp="22xn7phw4z813">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-683" data-mp="2qoix68d4dr56">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Calabasas to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>

      <h2 data-id="element-684" data-mp="3ejkwosnvnm7x">Related Detailing Services</h2>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-685" data-mp="3eij95opod79b">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-686" data-mp="39khqh4w5v9yd">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-687" data-mp="2hvy270ad6dx4">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-688" data-mp="b1ua0nsf8zto">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/ceramic-coating" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-689" data-mp="24ll3ko4qerzl">
          Ceramic Coating &rarr;
        </Link>
      </div>
    </ServicePageLayout>;
}